import { createContext, useContext } from 'react'

const BuilderStoreContext = createContext(null)

function BuilderStoreProvider({ store, children }) {
  return (
    <BuilderStoreContext.Provider value={store}>
      {children}
    </BuilderStoreContext.Provider>
  )
}

function useBuilderStore() {
  const store = useContext(BuilderStoreContext)
  return store
}

export {
  BuilderStoreProvider,
  useBuilderStore,
}
